import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { SearchSales, SearchSalesVariables } from "./types/SearchSales";

export const searchSales = gql`
  ${pageInfoFragment}
  query SearchSales($after: String, $first: Int!, $query: String!) {
    search: sales(after: $after, first: $first, filter: { search: $query }) {
      edges {
        node {
          id
          name
          value
          startDate
          endDate
          description
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchSales, SearchSalesVariables>(
  searchSales
);
